import {
  PROJECT_FETCHING,
  PROJECT_FAILED,
  PROJECT_SUCCESS,
} from "../actions/types";

const initialState = {
  result: null,
  isFetching: false,
  isError: false,
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case PROJECT_FETCHING:
      return { ...state, result: null, isFetching: true, isError: false };
    case PROJECT_FAILED:
      return { ...state, result: null, isFetching: false, isError: true };
    case PROJECT_SUCCESS:
      return { ...state, result: payload, isFetching: false, isError: false };
    default:
      return state;
  }
}
